import { getCustomerUuid, useCart, useCustomerAutoshipSubscriptions, usePageLayout } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';

export const useNormalizeAutoshipSubscriptionData = () => {
    const { cart } = useCart();
    const { product } = useProduct();
    const { autoshipData } = useCustomerAutoshipSubscriptions();
    const nextSubscriptionOrderId = autoshipData?.data?.nextSubscriptionOrderId;
    const { user } = usePageLayout();
    const customerUuid = getCustomerUuid(user);

    return (formData: FormFields) => {
        if (!product || !customerUuid || !nextSubscriptionOrderId) {
            return null;
        }

        const isOneTimeOrder = formData.autoshipUnit === 'one_time';

        return {
            customerId: customerUuid,
            isOneTimeOrder,
            productId: product.sku,
            quantity: formData.quantity,
            basketId: cart?.basketId ?? '',
            unitOfMeasure: isOneTimeOrder ? null : Number(formData.autoshipUnit),
            frequencyAmount: isOneTimeOrder ? null : Number(formData.autoshipFrequency),
            publicId: nextSubscriptionOrderId,
        };
    };
};
